import { render, staticRenderFns } from "./DriverTabAccount.vue?vue&type=template&id=764a436b&"
import script from "./DriverTabAccount.vue?vue&type=script&lang=js&"
export * from "./DriverTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./DriverTabAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports